module.exports = require("core-js-pure/stable/instance/includes");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/instance/includes.js
// module id = 3477
// module chunks = 25